<template functional>
  <td
    class="dataset-td"
    :style="[props.column.pre_style]"
    v-bind="data.attrs"
    @click="listeners['edit'](props.row)"
    @showCombined="listeners['showCombined'](props.row)"
    @editButton="listeners['editButton'](props.row)"
  >
    <component
      :is="$options.getComponent(props)"
      :row="props.row"
      :value="$options.getValue(props) || ''"
      :column="props.column"
      :addons="$options.getIncludes(props)"
      :store="props.store"
      :meta="props.meta"
      :update-meta="props.updateMeta"
      :force-fetch="props.forceFetch"
      :checkedrows.sync="props.checkedrows"
      @editButton="listeners['editButton'](props.row)"
      @delete="listeners['delete'](props.row)"
      @showCombined="listeners['showCombined'](props.row)"
    />
  </td>
</template>

<script>
export default {
  name: 'DatasetTd',
  props: {
    column: { type: Object, default: () => ({}) },
    row: { type: Object, default: () => ({}) },
    store: { type: Object, default: () => null },
    loading: { type: Boolean, default: () => false },
    meta: { type: Object, default: () => null },
    updateMeta: { type: Function, default: () => null },
    forceFetch: { type: Function, default: () => null },
    checkedrows: {type: Array, default: () => []}
  },
  getValue: props => {
    const { request_field } = props.column
    return props.row[request_field]
  },
  getComponent: props => {
    const { format, component } = props.column
    // use bult-in if we need
    if (format === 'TEXT') return require('./cell-modules/text').default
    if (format === 'TEXT_BOLD')
      return require('./cell-modules/text-bold').default
    if (format === 'TAG') return require('./cell-modules/tag').default
    if (format === 'CHECKBOX') return require('./cell-modules/checkbox').default
    if (format === 'CUSTOM') {
      if (!component) {
        const label =
          props.column.label && props.column.label.length
            ? props.column.label
            : props.column.key
        throw new Error(`column ${label} has not config how to show value`)
      }
      return component
    }
    return format
  },

  // - get values from [includes] values
  getIncludes: props => {
    const inc = props.column.includes
    return inc.reduce((o, key) => {
      o[key] = props.row[key]
      return o
    }, {})
  },
}
</script>

<style lang="scss">
// .dataset-td {
//   white-space: nowrap;
// }
</style>
